import { initializeApp } from "firebase/app";
import { 
  initializeAuth, 
  indexedDBLocalPersistence, 
  browserLocalPersistence, 
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAAknrNPp5m8tTzTW8znxHAITuLJUXxI70",
  authDomain: "gamasains-a23fd.firebaseapp.com",
  projectId: "gamasains-a23fd",
  storageBucket: "gamasains-a23fd.appspot.com",
  messagingSenderId: "904819787775",
  appId: "1:904819787775:web:9687cfd1fc922d02b849ca",
  measurementId: "G-2XTQKGHVVX",
};

const firebaseApp = initializeApp(firebaseConfig);

// Inisialisasi Auth dengan prioritas penyimpanan yang lebih aman untuk iOS
const auth = initializeAuth(firebaseApp, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence]
});

export { firebaseApp, auth };